"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const ItemDefinition_1 = require("./ItemDefinition");
const zod_1 = require("zod");
const configSchema = zod_1.z.object({});
const dataSchema = zod_1.z.object({
    userEntries: zod_1.z
        .array(zod_1.z.object({
        id: zod_1.z.string().uuid(),
    }, (0, validation_1.labelZodErrors)("User Entry")))
        .min(1, "Please pick at least one user."),
});
exports.default = new ItemDefinition_1.ItemDefinition("UserPicker", configSchema, dataSchema, new validation_1.ValidatorPipeline("UserPicker Config Validator", []), new validation_1.ValidatorPipeline("UserPicker Data Validator", []));
//# sourceMappingURL=UserPicker.js.map